import React, { Component } from "react";
import PropTypes from "prop-types";
import { getParam } from "../../../utils/uriParams";
import Moment from "moment/moment";
import { withRouter} from "../../../utils/withRouter";

class DataTableX extends Component {
  constructor(p) {
    super(p);
    this.state = {
      rows: p.rows,
      meta: p.meta,
      pageNum: p.pageNum,
      pageSize: p.pageSize,
      displayFilter: false,
      showFooter: p.showFooter,
      searchCondition: "contains",
      searchText: p.searchText,
      columnsShowing: p.columns.reduce((acc, obj) => {
        if (typeof obj.showing === "undefined" || obj.showing === true)
          acc.push(obj.field);
        return acc;
      }, []),
      searchFields:
        p.searchFields ||
        p.columns.reduce((acc, obj) => {
          if (obj.filterable) acc[obj.field] = true;
          return acc;
        }, {}),
    };

    this.state = Object.assign(this.state, this.handleQueryParams(true));
    this.state.rows = this.searchData(true);

    this.handleColumnChange = this.handleColumnChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.searchText !== this.props.searchText) {
      this.setState(
        {
          searchText: this.props.searchText,
        },
        () => {
          this.searchData(false);
        }
      );
    } else if (
      prevProps.location.search !== this.props.location.search ||
      prevProps.rows.length !== this.props.rows.length
    ) {
      this.handleQueryParams(false);
    }
  }

  handleQueryParams(init) {
    let obj = {};
    let val = getParam("value", this.props.location.search, "");
    if (val.length > 0) {
      obj.searchText = decodeURIComponent(val);
    }
    let filter = getParam("filters", this.props.location.search, "");
    if (filter.length > 0) {
      obj.searchFields = { ...this.state.searchFields };
      for (let f in this.state.searchFields) {
        obj.searchFields[f] = f === filter ? true : false;
      }
    }
    if (init === true) return obj;
    this.setState(obj, () => this.searchData());
  }

  compareStr(a) {
    if (!a) return false;
    let parts = this.state.searchText.split(" OR ");

    if (this.state.searchCondition === "equals") {
      for (let i = 0; i < parts.length; i++) {
        if (parts[i].toLowerCase() === a.toString().toLowerCase()) {
          return true;
        }
      }
    } else if (this.state.searchCondition === "startswith") {
      for (let i = 0; i < parts.length; i++) {
        if (a.toString().toLowerCase().indexOf(parts[i].toLowerCase()) === 0) {
          return true;
        }
      }
    } else {
      for (let i = 0; i < parts.length; i++) {
        if (a.toString().toLowerCase().indexOf(parts[i].toLowerCase()) > -1) {
          return true;
        }
      }
    }
    return false;
  }

  searchData(init) {
    let filtered = this.props.rows;
    if (this.state.searchText.length > 0) {
      let valueGetters = {};
      this.props.columns.forEach((col) => {
        if (this.state.searchFields[col.field] === true) {
          valueGetters[col.field] =
            typeof col.valueGetter === "function"
              ? col.valueGetter
              : (params) => params.value;
        }
      });

      filtered = this.props.rows.filter((row) => {
        for (let filter in valueGetters) {
          let val = valueGetters[filter]({ value: row[filter], row: row });
          if (this.compareStr(val) === true) {
            return true;
          }
        }
        return false;
      });
    }
    if (init === true) return filtered;
    this.setState({ rows: filtered });
  }

  handleConditionChange(cond) {
    this.setState({ searchCondition: cond }, () => this.searchData());
  }

  handleFiltering(name, checked) {
    let filters = { ...this.state.searchFields };
    filters[name] = !filters[name];
    this.setState({ searchFields: filters }, () => this.searchData());
  }

  handleSearchText(val) {
    this.setState({ searchText: val }, () => this.searchData());
  }

  handleChangePage = (event, newPage) => {
    this.setState({ pageNum: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ pageSize: parseInt(event.target.value), pageNum: 0 });
  };

  handleColumnChange(field) {
    const old = [...this.state.columnsShowing];
    const has = this.state.columnsShowing.indexOf(field);
    if (has > -1) {
      old.splice(has, 1);
    } else {
      old.push(field);
    }
    this.setState({ columnsShowing: old });
  }

  handleSort(field) {
    let rows = [...this.state.rows];
    let sorters = [];
    this.props.columns.forEach((col) => {
      if (col.field === field) {
        if (typeof col.sortDir === "undefined") col.sortDir = 1;
        else col.sortDir = col.sortDir === -1 ? 0 : col.sortDir === 0 ? 1 : -1; // reverse
      }
      if (col.sortable === true && (col.sortDir === -1 || col.sortDir === 1)) {
        sorters.push(col);
      }
    });

    rows.sort((row, row2) => {
      for (let c = 0; c < sorters.length; c++) {
        let col = sorters[c];
        let a = col.valueGetter
          ? col.valueGetter({
              row: row,
              value: row[col.field],
              forSorting: true,
            })
          : row[col.field];
        let b = col.valueGetter
          ? col.valueGetter({
              row: row2,
              value: row2[col.field],
              forSorting: true,
            })
          : row2[col.field];

        let compare = 0;
        if (typeof a == "string") {
          if (!b) b = "";
          compare =
            col.sortDir === -1 ? b.localeCompare(a) : a.localeCompare(b);
        } else if (typeof a == "number") {
          if (!b) b = -1;
          compare = col.sortDir === -1 ? b - a : a - b;
        } else if (typeof a == "boolean") {
          compare =
            col.sortDir === -1
              ? a === b
                ? 0
                : a
                ? -1
                : 1
              : a === b
              ? 0
              : a
              ? 1
              : -1;
        }
        if (compare !== 0) return compare; // else continue
      }

      return 0;
    });
    this.setState({ rows: rows });
  }

  toggleFilterInput = () => {
    this.setState({ displayFilter: !this.state.displayFilter });
  };

  buildFooter = () => {
    if (this.state.rows.length < 2) return null;

    const cells = [];
    this.props.columns.forEach((o, i) => {
      if (!this.state.columnsShowing.includes(o.field)) {
        // do nothing
      } else if (o.type === "number") {
        let sum = 0;
        this.state.rows.forEach((d) => {
          if (d[o.field]) {
            // can be null
            sum += d[o.field];
          }
        });
        cells.push(<td key={`foot${i}`}>{sum}</td>);
      } else if (o.type === "time") {
        const timestamps = [...this.state.rows];
        timestamps.sort((a, b) => new Date(a[o.field]) - new Date(b[o.field]));
        const firstTimestampMs = new Date(timestamps[0][o.field]).getTime();
        const lastTimestampMs = new Date(
          timestamps[timestamps.length - 1][o.field]
        ).getTime();
        const durationSeconds = (lastTimestampMs - firstTimestampMs) / 1000;

        cells.push(<td>{this.formatDuration(durationSeconds)}</td>);
      } else {
        cells.push(<td></td>);
      }
    });

    return (
      <tfoot>
        <tr>{cells}</tr>
      </tfoot>
    );
  };

  formatDuration(durationSeconds) {
    const days = Math.floor(durationSeconds / (24 * 3600));
    const hours = Math.floor((durationSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((durationSeconds % 3600) / 60);
    const seconds = durationSeconds % 60;

    const parts = [];

    if (days > 0) {
      parts.push(`${days} day${days !== 1 ? "s" : ""}`);
    }
    if (hours > 0) {
      parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
    }
    if (minutes > 0) {
      parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
    }
    if (seconds > 0 || parts.length === 0) {
      parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);
    }

    return parts.join(", ");
  }

  formatTime(val) {
    if (!val) {
      return "--";
    }
    return new Moment(val).format("MM/DD LT");
  }

  render() {
    let startIndex = this.state.pageNum * this.state.pageSize;
    let pageRows = this.state.rows.slice(
      startIndex,
      Math.min(startIndex + this.state.pageSize, this.state.rows.length)
    );

    const filterables = this.props.columns.reduce((acc, o) => {
      if (o.filterable) {
        acc.push(
          <div key={"filter-" + o.field}>
            <span>{o.headerName}</span>
            <input
              type={"checkbox"}
              checked={this.state.searchFields[o.field] === true}
              onChange={(e) => this.handleFiltering(o.field, e.target.checked)}
              name={o.field}
              color="primary"
            />
          </div>
        );
      }
      return acc;
    }, []);

    return (
      <div style={{ position: "relative" }}>
        <div className="info-panel-heading">
          <div className={"row"}>
            <div className={"col"}>{this.props.title}</div>
            <div style={{ fontSize: 10 }}>
              <span>
                {this.state.rows.length} of {this.props.rows.length} rows
              </span>
              {this.state.rows.length > 1 && (
                <span
                  onClick={this.toggleFilterInput}
                  style={{ marginLeft: 5, cursor: "pointer" }}
                >
                  <i className="fa fa-filter" aria-hidden="true" />
                </span>
              )}
            </div>
          </div>
        </div>
        {this.props.searchTools === true && (
          <div
            className={"info-panel-heading"}
            style={{ height: this.state.displayFilter ? "auto" : 0 }}
          >
            <div className={"row"} style={{ gap: 3 }}>
              <div className={"col"}>
                <select
                  multiple={true}
                  size={1}
                  style={{ height: 38 }}
                  value={this.state.columnsShowing}
                  onChange={(e) => this.handleColumnChange(e.target.value)}
                >
                  {this.props.columns.map((col, i) => (
                    <option
                      key={`colMenuChanger${col.field}`}
                      value={col.field}
                      selected={this.state.columnsShowing.includes(col.field)}
                    >
                      {col.headerName}
                    </option>
                  ))}
                </select>
              </div>
              <div className={"col"}>
                <select
                  style={{ color: "#fff" }}
                  label={false}
                  value={this.state.searchCondition}
                  onChange={(e) => this.handleConditionChange(e.target.value)}
                >
                  <option disabled={false}>Showing</option>
                  <option value={"contains"}>Contains</option>
                  <option value={"equals"}>Equals</option>
                  <option value={"startswith"}>Starts with</option>
                </select>
              </div>
              <div className={"col"} style={{ flexGrow: 1 }}>
                <input
                  type={"text"}
                  value={this.state.searchText}
                  onChange={(e) => this.handleSearchText(e.currentTarget.value)}
                  placeholder="Search..."
                  autoFocus={true}
                />
              </div>
              <div className={"col"} item>
                {filterables.length > 1 && filterables}
              </div>
            </div>
          </div>
        )}

        <div className={"info-panel"} style={{ padding: "0 4px" }}>
          <table className={"tbl-med"}>
            <thead>
              <tr>
                {this.props.columns.map((o, i) => {
                  if (!this.state.columnsShowing.includes(o.field)) return null; // hidden
                  let cell = o.headerName;
                  if (o.renderHeader) {
                    cell = o.renderHeader(o);
                  }
                  let attrs = { key: o.field + "head", variant: "head" };
                  if (o.sortable === true && this.state.rows.length > 1) {
                    attrs["aria-sort"] =
                      o.sortDir === 1
                        ? "asc"
                        : o.sortDir === -1
                        ? "desc"
                        : "false";
                    attrs.onClick = (e) => this.handleSort(o.field);
                  }
                  return (
                    <th {...attrs} className={"tableHeader"}>
                      {o.sortable === true && this.state.rows.length > 1 && (
                        <span className={"sortIcon"}></span>
                      )}
                      {cell}
                      {i < this.props.columns.length - 1 && (
                        <hr
                          style={{
                            position: "absolute",
                            right: 5,
                            top: "25%",
                            height: "50%",
                          }}
                        />
                      )}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {this.state.loading === true && (
                <div className={"loading"}>loading</div>
              )}
              {pageRows.map((row, i) => {
                let keyId = this.props.getRowId
                  ? this.props.getRowId(row)
                  : "row-" + i;
                let rowStyle = this.props.getRowStyle ? this.props.getRowStyle(row) : {};
                let tr1 = this.props.columns.map((o, ci) => {
                  if (!this.state.columnsShowing.includes(o.field)) return null;
                  let attrs = {
                    padding: o.padding || "default",
                    key: keyId + o.field,
                  };
                  let cell = row[o.field];
                  if (typeof cell !== "object") {
                    attrs.title =
                      typeof cell === "string" && cell.length > 10
                        ? cell.substr(0, 10) + "..."
                        : cell;

                    if (o.type === "time") {
                      cell = this.formatTime(cell);
                    }
                  }
                  if (o.style) {
                    attrs.style = o.style;
                  }
                  if (typeof o.onClick === "function") {
                    if (!attrs.style) attrs.style = {};
                    attrs.style.cursor = "pointer";
                    attrs.onClick = () => o.onClick(row);
                  }
                  if (o.renderCell)
                    cell = o.renderCell({ value: cell, row: row });
                  else if (o.valueGetter)
                    cell = o.valueGetter({ value: cell, row: row });
                  return <td {...attrs}>{cell}</td>;
                });
                return <tr key={keyId} style={rowStyle}>{tr1}</tr>;
              })}
            </tbody>
            {this.props.showFooter && this.buildFooter()}
          </table>
        </div>
      </div>
    );
  }
}

DataTableX.defaultProps = {
  loading: false,
  pageSize: 1000000,
  pageNum: 0,
  rowsPerPageOptions: [5, 25, 50, 100],
  searchText: "",
  rows: [],
  searchFields: false,
  searchTools: true,
};

DataTableX.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  pageSize: PropTypes.number,
  loading: PropTypes.bool,
  rowsPerPageOptions: PropTypes.array,
  getRowId: PropTypes.func,
  getRowStyle: PropTypes.func,
  pageNum: PropTypes.number,
  searchText: PropTypes.string,
  searchFields: PropTypes.any,
  searchTools: PropTypes.bool,
};

export default withRouter(DataTableX);
